import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { fetchLeads } from "../../services/leadsService";

const columns = [
  { id: "created_at", label: "Date", minWidth: 200 },
  { id: "business_name", label: "Business Name", minWidth: 200 },
  { id: "business_type", label: "Business Type", minWidth: 180 },
  {
    id: "contact_name",
    label: "Contact Name",
    minWidth: 170,
    align: "right",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "position",
    label: "Position",
    minWidth: 170,
    align: "right",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "phone",
    label: "Phone",
    minWidth: 170,
    align: "right",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "email",
    label: "Email",
    minWidth: 170,
    align: "right",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "notes",
    label: "Notes",
    minWidth: 370,
    align: "right",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  // {
  //   id: "instagram",
  //   label: "Instagram",
  //   minWidth: 170,
  //   align: "right",
  //   format: (value: number) => value.toLocaleString("en-US"),
  // },
  // {
  //   id: "website",
  //   label: "Website",
  //   minWidth: 170,
  //   align: "right",
  //   format: (value: number) => value.toLocaleString("en-US"),
  // },
  {
    id: "street",
    label: "Street",
    minWidth: 170,
    align: "right",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "city",
    label: "City",
    minWidth: 170,
    align: "right",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "province",
    label: "Province",
    minWidth: 170,
    align: "right",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "postal_code",
    label: "Postal Code",
    minWidth: 170,
    align: "right",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "products",
    label: "Products",
    minWidth: 170,
    align: "right",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  // {
  //   id: "monthly_volume",
  //   label: "Monthly Volume",
  //   minWidth: 170,
  //   align: "right",
  //   format: (value: number) => value.toLocaleString("en-US"),
  // },
  // {
  //   id: "has_supplier",
  //   label: "Has Supplier",
  //   minWidth: 170,
  //   align: "right",
  //   format: (value: number) => value.toLocaleString("en-US"),
  // },
  {
    id: "supplier",
    label: "Supplier",
    minWidth: 170,
    align: "right",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  // {
  //   id: "start_timeline",
  //   label: "Start Timeline",
  //   minWidth: 170,
  //   align: "right",
  //   format: (value: number) => value.toLocaleString("en-US"),
  // },
  // {
  //   id: "decision_maker",
  //   label: "Decision Maker",
  //   minWidth: 170,
  //   align: "right",
  //   format: (value: number) => value.toLocaleString("en-US"),
  // },
  // {
  //   id: "follow_up_method",
  //   label: "Follow Up Method",
  //   minWidth: 170,
  //   align: "right",
  //   format: (value: number) => value.toLocaleString("en-US"),
  // },
  {
    id: "contact_method",
    label: "Contact Method",
    minWidth: 170,
    align: "right",
    format: (value: number) => value.toLocaleString("en-US"),
  },
];
type FilterProps = {
  supplier: string;
  monthly_volume: string;
  has_supplier: string;
};
const initialFilter: FilterProps = {
  supplier: "",
  monthly_volume: "",
  has_supplier: "",
};
const LeadsList = () => {
  const [rows, setRows] = useState([]);
  const [filters, setFilters] = useState<FilterProps>(initialFilter);
  const getData = async (filters?: FilterProps) => {
    const response = await fetchLeads(filters);
    setRows(response);
    // if (response.length > 0) {
    // }
  };
  useEffect(() => {
    getData(filters);
  }, [filters]);
  const handleReset = () => {
    setFilters(initialFilter);
  };
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);

    const day = date.getDate();

    const getOrdinal = (n: number) => {
      if (n > 3 && n < 21) return "th";

      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    const formattedDate = date.toLocaleDateString("en-CA", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    const formattedTime = date.toLocaleTimeString("en-CA", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    return `${day}${getOrdinal(day)} ${formattedDate.replace(
      day.toString(),
      "",
    )} 
    (${formattedTime})
    `;
  };

  return (
    <Box>
      <Typography variant="h6">Leads List</Typography>
      <Box
        sx={{
          // height: "10px",
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          padding: 1,
          gap: 2,
        }}
      >
        <TextField
          id="outlined-basic"
          label="Search"
          variant="outlined"
          size="small"
        />
        <FormControl size="small" sx={{ minWidth: 220 }}>
          <InputLabel id="supplier-label">Has Supplier</InputLabel>
          <Select
            label="Has Supplier"
            value={filters.supplier}
            onChange={(e) =>
              setFilters({ ...filters, supplier: e.target.value })
            }
          >
            <MenuItem value="Yes">Yes</MenuItem>
            <MenuItem value="No">No</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 220 }}>
          <InputLabel id="monthly_volume-label">Monthly Volume</InputLabel>
          <Select
            label="Monthly Volume"
            value={filters.monthly_volume}
            onChange={(e) =>
              setFilters({ ...filters, monthly_volume: e.target.value })
            }
          >
            <MenuItem value="Under $500">Under $500</MenuItem>
            <MenuItem value="$500 - $2,000">$500 - $2,000</MenuItem>
            <MenuItem value="$2,000 - $5,000">$2,000 - $5,000</MenuItem>
            <MenuItem value="$5,000+">$5,000+</MenuItem>
          </Select>
        </FormControl>
        <Button variant="outlined" color="error" onClick={handleReset}>
          Reset
        </Button>
      </Box>
      <Box>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    sx={{
                      minWidth: column.minWidth,
                      backgroundColor: "#035a1c",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row: any) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  {columns.map((column) => (
                    <TableCell key={column.id} component="th" scope="row">
                      {column.id === "created_at"
                        ? formatDate(row[column.id])
                        : row[column.id]}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default LeadsList;
